/**
 * iOS 15.4 미만 WebView 는 BroadcastChannel 미지원(전역 부재)이고, 전역이 있어도
 * opaque origin 등 제한된 컨텍스트에선 생성자에서 예외가 발생한다. 모듈 평가 시점 크래시(흰 화면)를
 * 막기 위해 실패 시 null 로 강등한다 — 호출부는 다탭 동기만 생략하고 정상 동작해야 한다.
 */
export const createBroadcastChannel = (name: string): BroadcastChannel | null => {
  if (typeof BroadcastChannel === 'undefined') return null

  try {
    return new BroadcastChannel(name)
  } catch {
    return null
  }
}
